const TWO_MINUTES_MS = 120000;
export const TASK_QUEUES_POLL_INTERVAL = TWO_MINUTES_MS;
export const TASKS_POLL_INTERVAL = TWO_MINUTES_MS;